if (!customElements.get('rebuy-featured')) {
  class RebuyFeatured extends HTMLElement {
    constructor() {
      super();
      this.rebuyApiKey = this.dataset.rebuyApiKey;
      this.rebuySource = this.dataset.rebuySource;
      this.rebuyApiContainer = this.querySelector('#rebuy-api-container');
      this.swiper = null;
      this.leftArrow = this.querySelector('.custom__arrow-left-feat-prods');
      this.rightArrow = this.querySelector('.custom__arrow-right-feat-prods');
      this.sectionId = this.dataset.sectionId;
      this.cardDataCache = new Map();
    }

    connectedCallback() {
      this.initRebuyFeatured();
    }

    initRebuyFeatured() {
      if (this.rebuyApiContainer) {
        const rebuyTestSlider = this.rebuyApiContainer.querySelector('.custom__featured-slider');
        rebuyTestSlider.innerHTML = '';

        const requestParameters = new URLSearchParams({
          key: this.rebuyApiKey,
          source: this.rebuySource,
          format: "pretty",
          limit: 12
        });

        let fetchURL = ''

        if (this.rebuySource == '') {
          fetchURL = `https://rebuyengine.com/api/v1/products/recommended?${requestParameters}&limit=8`
        } else {
          fetchURL = 'https://rebuyengine.com/api/v1/custom/id/' + this.rebuySource + `?${requestParameters}&limit=8`
        }

        fetch(fetchURL)
          .then(response => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then(data => {
            const products = data.data;
            // Display the results using the same structure as card-product-rebuy
            if (products && products.length > 0) {
              // Add swiper class and create wrapper structure
              rebuyTestSlider.classList.add('swiper');
              let html = '<div class="swiper-wrapper">';
            
              products.forEach(product => {
                const productHandle = this.getProductHandle(product);
                // Format price - assuming product.price is in cents or already formatted
                const price = product.price ? (typeof product.price === 'number' ? (product.price / 100).toFixed(2) : product.price) : '0.00';
                const priceFormatted = '$' + price;
                
                // Get image URL - try different possible image fields
                const imageUrl = product.image.src || '';
                const imageAlt = product.image.alt || product.title || 'Product image';
                
                // Get hover image if available
                const hoverImageUrl = product.hover_image || product.secondary_image || '';
                
                html += `
                  <div class="swiper-slide">
                    <div class="card-wrapper underline-links-hover">
                      <div class="card card-wrapper card--standard card--media" style="--ratio-percent: 133%;">
                        <div class="card__inner color-background-2 ratio" style="--ratio-percent: 133%;">
                          ${imageUrl ? `
                            <div class="card__media">
                              <div class="media media--transparent media--hover-effect">
                                <a href="${product.link || '#'}" class="whole-card-link full-unstyled-link"><span class="visually-hidden">${product.title || 'Product Title'}</span></a>
      
                                <img
                                  src="${imageUrl}"
                                  alt="${imageAlt}"
                                  width="533"
                                  class="motion-reduce"
                                  loading="lazy"
                                >

                                <div class="hover-media" data-target="card-hover">
                                </div>

                                <button class="quick__shop-btn" data-id="${this.sectionId}-${product.id}" ${productHandle ? `data-product-handle="${productHandle}"` : ''}>Quick Shop</button>
                              </div>
                            </div>
                          ` : ''}
                        </div>
                        <div class="card__content">
                          <div class="card__badge top left" data-target="card-badge">
                          </div>
      
                          <div class="card__category">
                            <span class="overline">
                              <a href="${product.link || '#'}" class="unstyled-link opacity-hover">
                                ${product.product_type || 'Product'}
                              </a>
                            </span>
                          </div>
                          <div class="card__information">
                            <h3 class="card__heading h5">
                              <a href="${product.link || '#'}" class="full-unstyled-link">
                                ${product.title || 'Product Title'}
                              </a>
                            </h3>
                            <div class='jdgm-widget jdgm-preview-badge' data-target="card-reviews">
                            </div>
      
                            <div class="card-information">
                              <div class="price price--no-compare card-price" data-target="card-price">
                                <div class="price__container">
                                  <div class="price__regular">
                                    <span class="h3 price-item price-item--regular">
                                      ${priceFormatted}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                `;
              });

              html += '</div><div class="swiper-pagination"></div>';
              rebuyTestSlider.innerHTML = html;
    
              // Initialize Swiper slider
              const paginationEl = rebuyTestSlider.querySelector('.swiper-pagination');
              
              // Check if Swiper is already initialized
              if (!rebuyTestSlider.swiper) {
                this.swiper = new Swiper(rebuyTestSlider, {
                  slidesPerView: 'auto',
                  spaceBetween: 0,
                  loop: false,
                  speed: 500,
                  centerInsufficientSlides: true,
                  centeredSlides: true,
                  grabCursor: true,
                  navigation: {
                    nextEl: this.rightArrow,
                    prevEl: this.leftArrow,
                  },
                  pagination: {
                    el: paginationEl,
                    clickable: true,
                    renderBullet: function (index, className) {
                      return '<div class="' + className + ' recommendations-slide-dot">&nbsp;</div>';
                    },
                  },
                  breakpoints: {
                    1000: {
                      slidesPerView: 4,
                      centeredSlides: false,
                    }
                  },
                  on: {
                    init: () => {
                      this.handleArrowVisibility();
                    },
                    slideChange: () => {
                      this.handleArrowVisibility();
                    },
                    resize: () => {
                      this.handleArrowVisibility();
                    }
                  }
                });
              }

              // Update card data-targets with server-rendered quickshop fragments
              this.updateCardTargets();
    
            } else {
              rebuyTestSlider.innerHTML = '<p>No products found in Rebuy API response</p>';
            }
          })
          .catch(error => {
            console.error('Rebuy API error:', error);
            rebuyTestSlider.innerHTML = `<p style="color: red;">Error loading Rebuy data: ${error.message}</p>`;
          });        
      }
    }

    getProductHandle(product) {
      if (product && typeof product.handle === 'string' && product.handle) {
        return product.handle;
      }

      const link = product && typeof product.link === 'string' ? product.link : '';
      const match = link.match(/\/products\/([^/?#]+)/i);

      return match ? decodeURIComponent(match[1]) : '';
    }

    async fetchCardData(handle) {
      if (!handle) return null;
      if (this.cardDataCache.has(handle)) return this.cardDataCache.get(handle);

      const params = new URLSearchParams({
        section_id: 'quick-shop-modal-render'
      });

      const response = await fetch(`/products/${handle}?${params.toString()}`);
      if (!response.ok) return null;

      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const modal = parsed.querySelector('.modal.quickshop');
      if (!modal) return null;

      const data = {
        hover: modal.querySelector('[data-card-hover]')?.innerHTML || '',
        badge: modal.querySelector('[data-card-badge]')?.innerHTML || '',
        reviews: modal.querySelector('[data-card-reviews]')?.innerHTML || '',
        price: modal.querySelector('[data-card-price]')?.innerHTML || ''
      };

      this.cardDataCache.set(handle, data);
      return data;
    }

    /**
     * For each card-wrapper, find the corresponding quickshop modal by product id,
     * and replace the content of data-target elements (card-hover, card-badge, card-price)
     * with the content from the modal's data-card-* elements.
     */
    async updateCardTargets() {
      // For each card-wrapper
      const cardWrappers = this.querySelectorAll('.card-wrapper.underline-links-hover');
      cardWrappers.forEach(async (card) => {
        // Find product id from the quick__shop-btn inside the card
        const quickShopBtn = card.querySelector('.quick__shop-btn[data-id]');

        if (!quickShopBtn) return;
        const productHandle = quickShopBtn.getAttribute('data-product-handle');
        const data = await this.fetchCardData(productHandle);
        if (!data) return;

        // For each data-target, replace with modal's data-card-* content
        const targets = [
          { card: card.querySelector('[data-target="card-hover"]'), html: data.hover },
          { card: card.querySelector('[data-target="card-badge"]'), html: data.badge },
          { card: card.querySelector('[data-target="card-reviews"]'), html: data.reviews },
          { card: card.querySelector('[data-target="card-price"]'), html: data.price },
        ];

        targets.forEach(({ card, html }) => {
          if (card && html) {
            card.innerHTML = html;
          }
        });
      });
    }

    handleArrowVisibility() {
      if (!this.swiper || !this.leftArrow || !this.rightArrow) return;

      const totalSlides = this.swiper.slides.length;
      const slidesPerView = typeof this.swiper.params.slidesPerView === 'number' 
        ? this.swiper.params.slidesPerView 
        : this.swiper.slides.length;
      const isLoop = this.swiper.params.loop;

      // Show/hide arrows based on number of slides
      if (totalSlides <= slidesPerView && !isLoop) {
        this.leftArrow.classList.add('custom__arrow--hidden');
        this.rightArrow.classList.add('custom__arrow--hidden');
      } else {
        this.leftArrow.classList.remove('custom__arrow--hidden');
        this.rightArrow.classList.remove('custom__arrow--hidden');
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  customElements.define('rebuy-featured', RebuyFeatured);
}
